import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { WorkflowStateModalComponent } from './workflow-state-modal/workflow-state-modal.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-workflowstateconfig',
  templateUrl: './workflowstateconfig.component.html',
  styleUrls: ['./workflowstateconfig.component.scss']
})
export class WorkflowstateconfigComponent implements OnInit {
  columnDefs:any=[];
  rowData: any=[];
  selectedRow: any;
  gridApi: GridApi;
  isSettings:boolean =true;
  operations;
  screencode: any;


  constructor(
    public modalService: NgbModal,
    public modalRef: NgbActiveModal,
    public administrationSummarySerice:AdministrationSummaryService,
    public route: ActivatedRoute,
    ){
      this.screencode = route.snapshot.params['code'];
    }

    ngOnInit(){
      this.columnDefs = [
        {
          "headerName": "Name",
          "field": "NAME"
        },{
          "headerName": "Display Name",
          "field": "DISPLAY_NAME"
        },
        {
          "headerName": "Status",
          "field": "StatusText"
        },
      ];

      this.getStateSummaryData();


  


    }

    // onRowDoubleClicked(event) {
    //   if(!this.modalService.hasOpenModals())
    //    {
    //     const ModelRef= this.modalService.open(WorkflowStateModalComponent, {
    //       backdrop: false,
    //       keyboard: false,
    //       windowClass: 'modal-md right modal-right',
    //       animation: true
    //     });
    //     ModelRef.componentInstance.Content={
    //       heading: 'Edit',
    //       screencode:'',
    //       id: this['self'].selectedRow.ID,
    //       ISFIXED: this['self'].selectedRow.ISFIXED

    //     }
    //     this['self'].ModelRef.result.then(result=>{
    //       this['self'].getStateSummaryData(); 
    //     })
    //    }
      
    //   }

  onSetGridApi(childreturnData)
   {
  this.gridApi=childreturnData;
   }
   onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
   onCallbackOperation(opr) {
    opr.callback();
  }
  

  Add() {
    let modalRef = this.modalService.open(WorkflowStateModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-md right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'Add',
        screencode:this.screencode,
        id: '' 
      }
      modalRef.result.then(result => {
        this.getStateSummaryData();
      })
   
  }

  onRowDoubleClicked(event) {
    ;
    if(!this.modalService.hasOpenModals()){
    const modalRef = this.modalService.open(WorkflowStateModalComponent, {
       backdrop: false,
       keyboard: false,
       windowClass:'modal-md right modal-right',
       animation: true
     });
     modalRef.componentInstance.Content={
       heading: 'Edit',
       screencode:'',
       id: this.selectedRow['ID'],
       ISFIXED: this.selectedRow['ISFIXED'],
     }
     modalRef.result.then(result=>{
       this.getStateSummaryData(); 
     })
   }
  }
   View() {
    let modalRef = this['self'].modalService.open(WorkflowStateModalComponent, {
       backdrop: false,
       keyboard: false,
       windowClass: 'modal-md right modal-right',
       animation: true
     });
     modalRef.componentInstance.Content={
       heading: 'View',
       screencode:'',
       id: this['self'].selectedRow.ID
     }
     modalRef.result.then(result => {
       this.getStateSummaryData();
     })
   }

   getStateSummaryData(){
    //;
    let moduleID="";
    switch(this.screencode)
    {
       case "ist":
        moduleID="2";
        break
        case "eap":
          moduleID="5";
        break
        case "grants":
          moduleID="4";
        break
    }
    this.administrationSummarySerice.getSummaryData("api/state/SummaryData?moduleId="+moduleID).subscribe((result)=>{
      this.rowData = result;
    });
}
  


}
